var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVentasSim(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-ventas_sim"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ventas_sim",
    "data-name": "ventas sim",
    clipPath: "url(#clip-ventas_sim)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2106",
    "data-name": "Grupo 2106",
    transform: "translate(-5.821 -15.494)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_813",
    "data-name": "Trazado 813",
    d: "M0,0H124.988V124.988H0Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2109",
    "data-name": "Grupo 2109",
    transform: "translate(-3.54 -7.672)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_819",
    "data-name": "Trazado 819",
    d: "M75.955,66.18v-54.2A10.887,10.887,0,0,0,65.01,1.14H21.234A10.887,10.887,0,0,0,10.29,11.976v54.2A10.872,10.872,0,0,0,21.234,77.017H65.01A10.872,10.872,0,0,0,75.955,66.18Z",
    transform: "translate(19.826 12.403)",
    fill: "none",
    stroke: "#6c637b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_820",
    "data-name": "Trazado 820",
    d: "M20.426,6.71,9.458,10.67A10.775,10.775,0,0,0,2.92,24.541L21.647,75.473a10.954,10.954,0,0,0,14.009,6.5L66.142,70.043",
    transform: "translate(8.613 20.04)",
    fill: "none",
    stroke: "#6c637b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_821",
    "data-name": "Trazado 821",
    d: "M17.14,12.57H44.512",
    transform: "translate(29.38 28.075)",
    fill: "none",
    stroke: "#6c637b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_822",
    "data-name": "Trazado 822",
    d: "M17.14,17.14H50",
    transform: "translate(29.38 34.341)",
    fill: "none",
    stroke: "#6c637b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_823",
    "data-name": "Trazado 823",
    d: "M17.14,21.71H33.568",
    transform: "translate(29.38 40.607)",
    fill: "none",
    stroke: "#6c637b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_824",
    "data-name": "Trazado 824",
    d: "M0,0H114.949V113.815H0Z",
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVentasSim);
export default __webpack_public_path__ + "static/media/ventas-sim.de5b5d922762da9ae15ba961a3a648f4.svg";
export { ForwardRef as ReactComponent };